import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Register from "@/pages/Register";
import Subscribe from "@/pages/Subscribe";
import Account from "@/pages/Account";
import Guarantee from "@/pages/Guarantee";
import Privacy from "@/pages/Privacy";
import LegalNotice from "@/pages/LegalNotice";
import SignupConfirmation from "@/pages/SignupConfirmation";
import Unsubscribe from "@/pages/Unsubscribe";
import Admin from "@/pages/Admin";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inscription" element={<Register />} />
        <Route path="/abonnement" element={<Subscribe />} />
        <Route path="/inscription/confirmation" element={<SignupConfirmation />} />
        <Route path="/espace-membre/*" element={<Navigate to="/mon-compte" replace />} />
        <Route path="/mon-compte" element={<Account />} />
        <Route path="/connexion" element={<Navigate to="/mon-compte" replace />} />
        <Route path="/garantie" element={<Guarantee />} />
        <Route path="/confidentialite" element={<Privacy />} />
        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/desabonnement" element={<Unsubscribe />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" toastOptions={{ className: "font-sans" }} />
    </BrowserRouter>
  );
}

export default App;
